import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import SendIcon from '@mui/icons-material/Send';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import ChipInput from 'material-ui-chip-input';
import { Editor } from '@tinymce/tinymce-react';
import { askGPT, update } from '../../../common/api';
import { toast } from 'react-toastify';
import { MdContentCopy } from 'react-icons/md';


const DisplayEmail = ( { user, templates, playbooks, sid, tid, close, objType } ) => {
    const [ template, setTemplate ] = useState( {} );
    const [ playbook, setPlaybook ] = useState( {} );
    const [ step, setStep ] = useState( {} );
    const [ name, setName ] = useState( '' );
    const [ active, setActive ] = useState( false );
    const [ repeats, setRepeats ] = useState( '' );
    const [ interval, setInterval ] = useState( 0 );
    const [ time, setTime ] = useState( '' );
    const [ from, setFrom ] = useState( '' );
    const [ signature, setSignature ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ to, setTo ] = useState( '' );
    const [ cc, setCc ] = useState( '' );
    const [ bcc, setBcc ] = useState( '' );
    const [ subject, setSubject ] = useState( '' );
    const [ body, setBody ] = useState( '' );
    const [ changesNotAllowed, setChangesNotAllowed ] = useState( true );
    const [ updating, setUpdating ] = useState( false );
    // const [ attachments, setAttachments ] = useState( [] );
    const [ videoOption, setVideoOption ] = useState( false );
    const [ showVideo, setShowVideo ] = useState( false );
    const [ loaded, setLoaded ] = useState( false );
    const [ showChatGPT, setShowChatGPT ] = useState( false );
    const [ chatRequest, setChatRequest ] = useState( '' );
    // const [ tmplUsed, setTmplUsed ] = useState( '' );
    // const [ sending, setSending ] = useState( false );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ prompt, setPrompt ] = useState( '' );
    const [ waiting, setWaiting ] = useState( false );
    const [ displayText, setDisplayText ] = useState( '' );
    const [ chatResp, setChatResp ] = useState( '' );
    const [ replace, setReplace ] = useState( false );
    const [ promptType, setPromptType ] = useState( 'freeform' );

    const editorRef = useRef( null );
    const tmplRef = useRef( null );
    tmplRef.current = allTmpls;
    const senderRef = useRef( null );
    senderRef.current = senderList;
    const bbObjRef = useRef( null );

    const insertAiResponse = () => {
        if ( replace ) {
            editorRef.current.selection.setContent( chatResp );
        } else {
            editorRef.current.insertContent( chatResp );
        }
        setReplace( false );
        setChatResp( '' );
        setDisplayText( '' );
        setShowChatGPT( false );
    };

    const insertAiSubject = ( sub ) => {
        setSubject( sub );
        setReplace( false );
        setChatResp( '' );
        setDisplayText( '' );
        setShowChatGPT( false );
    };

    const askAI = useCallback( async () => {
        setWaiting( true );
        const p = prompt;
        setPrompt( '' );
        
        const sent = await askGPT( user.aid, user.email, prompt, promptType, [] );
        setChatResp( sent );
        setWaiting( false );
    }, [ user.aid, user.email, prompt, promptType ] );

    const prepAskAI = async ( prompt, ptype ) => {
        setPromptType( ptype );
        setPrompt( prompt );
        setShowChatGPT( true );
        setReplace( true );
    };

    const handleEnter = async ( e ) => {
        if ( e.key === 'Enter' && !e.shiftKey ) {
            e.preventDefault();
            e.stopPropagation();
            await askAI();        
        }
    };

    const displayTypingEffect = useCallback( () => {
        if ( promptType !== 'subject-line-reco' ) {
            setDisplayText( chatResp );
        } else {
            const matches = chatResp.match( /Var1: "(.*?)"\nVar2: "(.*?)"\nVar3: "(.*)"/ );
            if ( matches ) {
                let resp = <ol>{ matches.map( ( sub, i ) => {
                    if ( i === 0 ) {
                        return null;
                    }
                    return <li>{sub} <Button variant='link' className='ms-2 p-0 tf-copy-button' onClick={ () => insertAiSubject( sub ) }><MdContentCopy /></Button></li>
                } )}</ol>;

                console.log( 'setting matches: ' + resp );
                setDisplayText( resp );
            } else {
                setDisplayText( chatResp );
            }
        }
    }, [ chatResp, promptType ] );
      
    const switchSender = ( fromEmail ) => {
        const s = senderList.find( f => f.email === fromEmail );
        if ( s ) {
            setFrom( s.email );
            setSignature( s.signature );
        }
    };

    const insertVideo = useCallback( ( l, i ) => {
        const v = `<a href="${l}"><img src="${i}" /></a>`;
        editorRef.current.insertContent( v );
    }, [ editorRef ] );

    const bbCallback = useCallback( ( video ) => {
        setShowVideo( false );
        bbObjRef.current.removeIframe();
        insertVideo( video.link, video.thumbnail );
    }, [ insertVideo ] );

    const bbRef = useCallback( ( r ) => {
        if ( r ) {
            bbObjRef.current.embedIframe( r );
        }
    }, [ bbObjRef ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    const loadTemplates = ( editor ) => {
        let list = [];
        
        console.log( 'load templates: ', tmplRef.current );
        if ( Object.keys( tmplRef.current ).length ) {
            Object.keys( tmplRef.current ).sort().forEach( name => {
                const t = tmplRef.current[name];

                if ( !t.objects || t.objects.includes( objType ) ) {
                    const content = t.body;
                    let fresh = false;
                    let sig = '';

                    list.push( {
                        type: 'menuitem',
                        text: t.name,
                        onAction: () => {
                            if ( t.to ) {
                                setTo( t.to );
                            }
                            if ( t.cc ) {
                                setCc( t.cc );
                            }
                            if ( t.bcc ) {
                                setBcc( t.bcc );
                            }
                            if ( t.from ) {
                                const s = senderRef.current.find( f => f.email === t.from );
                                if ( s ) {
                                    setFrom( t.from );
                                    sig = s.signature;
                                    fresh = true;
                                }
                            }
                            if ( t.subject ) {
                                setSubject( t.subject );
                            }

                            if ( fresh ) {
                                editor.setContent( content + '<br /><br />' + sig );
                            } else {
                                editor.insertContent( content );
                            }
                            
                            // setTmplUsed( t.tid );
                        }
                    } );
                }
            } );
        }
        if ( user.signature && user.signature.length ) {
            list.push( {
                type: 'menuitem',
                text: 'Signature',
                onAction: () => editor.insertContent( user.signature )
            } );
        }
        
        return ( list );
    }

    const loadPromptContextSubMenu = ( editor ) => {
        return [
            {
                type: 'item',
                text: 'Summarize',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'summarize' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: "item",
                text: 'Explain',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'explain' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Improve Writing',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'improve-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Simplify Writing',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'simplify-writing' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Overcome Objection',
                onAction: async () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'objection-handler' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        buttonApi.setEnabled( selectedText );
                    };
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            },
            {
                type: 'item',
                text: 'Check Guideline Accuracy',
                onAction: () => {
                    const selectedText = editor.selection.getContent({ format: 'text' });
                    if ( selectedText ) {
                        prepAskAI( selectedText, 'guideline-accuracy' );
                    }
                },
                onSetup: ( buttonApi ) => {
                    const updateState = () => {
                        const selectedText = editor.selection.getContent( { format: 'text' } );
                        // buttonApi.setEnabled( selectedText );
                    };
                    buttonApi.setEnabled( false );
                    editor.on( 'NodeChange', updateState );
                    return () => {
                        editor.off( 'NodeChange', updateState );
                    };
                },
            }
        ]
    }

    const loadPromptContextMenu = ( editor ) => {
        return [
            {
                type: 'submenu',
                text: 'MortgageGPT',
                icon: 'ai',
                getSubmenuItems: () => {
                    const selectedText = editor.selection.getContent( { format: 'text' } );
                    return selectedText ? loadPromptContextSubMenu( editor ) : ''; // Show submenu items if text is selected
                },
            }
        ]
    }

    const loadPromptMenu = ( editor ) => {
        return [ 
            {
                type: 'menuitem',
                text: 'Overcome Objections',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'objection-handler' );
                }
            }, 
            {
                type: 'menuitem',
                text: 'Check Guideline Accuracy',
                enabled: false,
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'guideline-accuracy' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Suggest a Subject Line',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'subject-line-reco' );
                }
            },
            {
                type: 'separator'
            },
            {
                type: 'menuitem',
                text: 'Summarize',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'summarize' );
                }
            },
            {
                type: 'menuitem',
                text: 'Explain',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'explain' );
                }
            },
            {
                type: 'menuitem',
                text: 'Improve Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'improve-writing' );
                }
            },
            {
                type: 'menuitem',
                text: 'Simplify Writing',
                onAction: () => {
                    prepAskAI( editorRef.current.getContent(), 'simplify-writing' );
                }
            }
        ]
    }

    const updateTemplate = async () => {
        setUpdating( true );
        
        await updatePlaybook();
        
        const b = editorRef.current.getContent();
        const t = templates[tid];
        const updated = await update( user.orgId, t.aid, user.email, 'template', tid, { body: b } );
        if ( updated.length ) {
            toast.success( `The template has been marked complete - nice work!`, { theme: 'dark' } );
        }
        setBody( b );
        setUpdating( false );
    }

    const updatePlaybook = async () => {
        const pb = JSON.parse( JSON.stringify( playbook ) );
        const idx = sid.replace( 'step_', '' );
        const s = pb.steps[parseInt( idx )];

        delete pb.aid;
        delete pb.pid;

        s.active = active;
        s.interval = interval;
        s.name = name;
        s.time = time;
        s.to = to;
        s.cc = cc;
        s.bcc = bcc;
        delete s.sid;

        console.log( playbook, pb, step, s );
        const updated = await update( user.orgId, playbook.aid, user.email, 'playbook', playbook.pid, pb  );
        if ( updated.length ) {
        //     toast.success( `The sms step has been updated - nice work!`, { theme: 'dark' } );
        }
    }

    useEffect( () => {
        if ( chatResp.length ) {
            displayTypingEffect();
        }
    }, [ chatResp, displayTypingEffect ] );

    useEffect( () => {
        if ( user && user.role === 'org-admin' ) {
            setChangesNotAllowed( false );
        }
    }, [ user ] );

    useEffect( () => {
        let temps = {};

        if ( user.meta.templates && user.meta.templates.length ) {
            user.meta.templates.forEach( t => {
                temps[t.name] = t;
            } );
        }
        if ( user.templates && user.templates.length ) {
            user.templates.forEach( t => {
                temps[t.name] = t;
            } );
        }

        setAllTmpls( temps );
    }, [ user.templates, user.meta.templates ] );

    useEffect( () => {
        if ( tid ) {
            const t = templates[tid];
            console.log( 't: ', t );
            if ( !t ) {
                setBody( 'Error: Missing template' );
                return;
            }

            const pb = playbooks[t.pid];
            if ( !pb || !pb.steps ) {
                console.log( 'All PBs: ', playbooks );
                setBody( 'Error: Missing playbook' );
                return;
            }

            let step;
            if ( sid ) {
                const idx = sid.replace( 'step_', '' );
                step = pb.steps[parseInt( idx )];
            }
            // const step = pb.steps.find( f => f.tid === tid );
            
            setTemplate( t );
            setPlaybook( pb );
            setStep( { ...step } );
            setTo( step.to );
            setCc( step.cc );
            setBcc( step.bcc );
            setName( step.name );
            setActive( step.active );
            setBody( t.body );
            setInterval( step.interval );
            setRepeats( step.repeats );
            setTime( step.time );
        }
    }, [ templates, playbooks, tid, sid, signature, senderList ] );

    useEffect( () => {
        if ( user.stack && user.stack.video ) {
            switch ( user.stack.video.type ) {
                case 'BombBomb':
                    if ( window.BbIntegrate ) {
                        const bb = new window.BbIntegrate( 'd4efd0d8-d20b-490c-0fc1-16f0424ba2e9', { onVideo: bbCallback } );
                        bbObjRef.current = bb;
                        setVideoOption( true );
                    }
                    break;

                default:
            }
        }
    }, [ user.stack, editorRef, bbCallback ] );

    useEffect( () => {
        if ( user ) {
            setFrom( user.email );
            setSignature( user.signature );

            let list = [ {
                email: user.email,
                name: user.name,
                signature: user.signature
            } ];

            if ( user.additionalEmailSenders && user.additionalEmailSenders.length ) {
                user.additionalEmailSenders.forEach( s => list.push( s ) );
            }
            
            setSenderList( list );
        }
    }, [ user ] );

    useEffect( () => {
        if ( replace && prompt.length ) {
            askAI();
        }
    }, [ replace, prompt, askAI ] );

    return (
        <Fragment>
            <Box sx={style}>
            <Container fluid className='tf-obj-data-element'>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">Subject</Form.Label>
                                <Form.Control className='tf-form-text-field me-1' style={ { border: 0 } } type="text" size="sm" value={name} onChange={ ( e ) => setName( e.target.value ) } />
                            </div>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">Active</Form.Label>
                                <Form.Check type='checkbox' size="sm" checked={active} onChange={ ( e ) => setActive( e.target.checked ) } />
                            </div>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">To</Form.Label>
                                <Form.Control type="text" style={ { border: 0 } } size="sm" value={to} onChange={ ( e ) => setTo( e.target.value ) } />
                            </div>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">Cc</Form.Label>
                                <Form.Control type="text" style={ { border: 0 } } size="sm" value={cc} onChange={ ( e ) => setCc( e.target.value ) } />
                            </div>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">Bcc</Form.Label>
                                <Form.Control type="text" style={ { border: 0 } } size="sm" value={bcc} onChange={ ( e ) => setBcc( e.target.value ) } />
                            </div>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">Interval</Form.Label>
                                <Form.Control type="text" style={ { border: 0 } } size="sm" value={interval} onChange={ ( e ) => setInterval( e.target.value ) } />
                            </div>
                        </Col>
                    </Row>
                    <Row className='py-2 align-items-center tf-email-header-row'>
                        <Col>
                            <div className="d-flex align-items-center">
                                <Form.Label className="tf-email-header-name me-2 mb-2">Time</Form.Label>
                                <Form.Control type="text" style={ { border: 0 } } size="sm" value={time} onChange={ ( e ) => setTime( e.target.value ) } />
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Editor
                        tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                        init={ { 
                            menubar: false, 
                            statusbar: false,
                            toolbar_mode: 'wrap',
                            visual: false,
                            content_style: 'body { font-family:Arial; font-size:12pt }',
                            setup: ( editor ) => {
                                editor.ui.registry.addButton( 'tfvideo', {
                                    icon: 'embed',
                                    tooltip: 'Insert Video',
                                    enabled: true,
                                    onAction: (_) => {
                                        setShowVideo( true );
                                    },
                                } );
                                editor.ui.registry.addMenuButton( 'tftmpl', {
                                    text: 'Insert Template...',
                                    fetch: ( cb ) => {
                                        const items = loadTemplates( editor );
                                        cb( items );
                                    }
                                } );
                                editor.ui.registry.addMenuButton( 'tfaiprompts', {
                                    icon: 'ai-prompt',
                                    fetch: ( cb ) => {
                                      const items = loadPromptMenu();
                                      cb( items );
                                    }
                                } );
                                editor.ui.registry.addButton( 'tfchatgpt', {
                                    icon: 'ai',
                                    tooltip: 'Ask MortgageGPT',
                                    onAction: () => {
                                        setShowChatGPT( true );
                                    }
                                });
                                
                                editor.ui.registry.addContextMenu( 'aiContextMenu', {
                                    update: ( element ) => {
                                        const selectedText = editor.selection.getContent( { format: 'text' } );
                                        return selectedText ? loadPromptContextMenu( editor ) : ''; // Show the custom item if text is selected
                                    },
                                } );
                            },
                            browser_spellcheck: true,
                            contextmenu: 'aiContextMenu link'
                        } }
                        onInit={ ( evt, editor ) => {
                            editorRef.current = editor;
                        } }
                        initialValue={body}
                        plugins='emoticons code lists link'
                        toolbar='fontfamily fontsize | bold italic underline strikethrough | forecolor backcolor | align bullist numlist | link | tfvideo emoticons tftmpl tfchatgpt tfaiprompts | code'
                />
                <Container fluid className='p-0 pt-2' id='tf-bbv-container' />
                <Container fluid>
                    <Row className='w-100 p-2 align-items-center'>
                        <Col className='ps-2 text-start' xs='auto'><Button variant='outline-dark' onClick={updateTemplate} disabled={changesNotAllowed || updating}>Save</Button></Col>
                        <Col className='ps-2 text-start'><Button variant='outline-dark' onClick={close}>Cancel</Button></Col>
                    </Row>
                </Container>
                <Modal open={showVideo} onClose={ () => setShowVideo( false ) }>
                    <Box sx={ { ...style, width: '820px' } } id='tf-bbv-container' ref={bbRef} />
                </Modal>
                <Modal open={showChatGPT} onClose={ () => setShowChatGPT( false ) }>
                    <Box 
                        id='tf-chatgpt-container'
                        sx={ {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '50%',
                            height: 500,
                            bgcolor: 'background.paper',
                            border: '2px solid #000',
                            boxShadow: 24,
                            p: 2,
                            display: 'flex',
                            flexDirection: 'column',
                        } }
                    >
                        <Button
                            variant="outline"
                            onClick={ () => setShowChatGPT( false ) }
                            style={ { position: 'absolute', top: '5px', right: '5px' } }
                        >
                            X
                        </Button>
                        <Typography variant="h5" id="modal-title">
                            AI Assistant
                        </Typography>
                        {
                            ( waiting ) ? (
                                <div style={ { height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' } }>
                                    <Spinner animation='border' />
                                </div>
                            ) : (
                                <Box sx={{ overflowY: 'auto', flex: 1, paddingTop: '20px' }}>
                                    {
                                        ( promptType !== 'subject-line-reco' ) ? (
                                            <div dangerouslySetInnerHTML={ { __html: displayText } } />
                                        ) : (
                                            displayText
                                        )
                                    }
                                </Box>
                            )
                        }
                        { chatResp && (
                            <Row className='w-100 p-2 align-items-center'>
                                <Col className='pe-2 text-end'><Button variant='outline-dark' color='primary' onClick={insertAiResponse}>Insert</Button></Col>
                                <Col className='ps-2 text-start'><Button variant='outline-dark' color='primary' onClick={ () => alert( 'try again' ) }>Try Again</Button></Col>
                            </Row>
                        ) }
                        <TextField 
                            id="chat-prompt" 
                            label="Send a message" 
                            multiline 
                            minRows={1} 
                            maxRows={5} 
                            value={prompt}
                            onChange={ ( e ) => { setPrompt( e.target.value ) } }
                            onKeyDown={ ( e ) => handleEnter( e ) }
                            variant="outlined" 
                            sx={ {
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                                    padding: '16.5px 14px'
                                },
                            } }
                            InputProps={ {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton edge="end" onClick={ () => askAI() }>
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            } }
                            fullWidth
                        />
                    </Box>
                </Modal>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    templates: state.templates.byId,
    playbooks: state.playbooks.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( DisplayEmail );